import React from 'react'
import {useSelector} from 'react-redux'
import { Fragment} from 'react'
import _ from 'lodash'
import RenderedHtmlContent from "../../../../shared/virtual_congress/components/rendered_html_content";

const Sidebar = () => {
  const sidebarCode = useSelector(state => state.sidebar_code).trim()
  const sidebarWidth = useSelector(state => state.sidebar_width) || "3"

  if (!sidebarCode) {
    return null
  }

  return <div className={`r-inner-container-sidebar col-md-${sidebarWidth}`}>
    <RenderedHtmlContent html={sidebarCode}/>
  </div>
}
export default Sidebar;